import * as React from 'react';

function NotFound() {
  return (
    <span>Not Found</span>
  );
}

export default NotFound;
